"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _ucfirstJs = _interopRequireDefault(require("ucfirst-js"));
var _StyleObject = _interopRequireDefault(require("./StyleObject.js"));
var _store = _interopRequireDefault(require("./store.js"));
var _cssNumberToUnit = _interopRequireDefault(require("./cssNumberToUnit.js"));
var _genStyleId = _interopRequireDefault(require("./genStyleId.js"));
var _reshowConstant = require("reshow-constant");
//@ts-check

var Browser = {
  webkit: "Webkit",
  ms: "ms",
  moz: "Moz"
};

/**
 * @param {any[]|any} css
 * @param {string|string[]|boolean} [selector]
 * @param {string|boolean} [styleId]
 * @returns {StyleObject|undefined}
 */
var createStyle = function createStyle(css, selector, styleId) {
  if (!css) {
    return;
  }
  var thisStyleId = null == styleId ? (0, _genStyleId["default"])() : /** @type {string}*/styleId;
  if (_store["default"].registry[thisStyleId]) {
    return _store["default"].registry[thisStyleId];
  }
  if (!(0, _reshowConstant.IS_ARRAY)(css)) {
    css = [css];
  }
  var styles = [];
  css.forEach(
  /**
   * @param {any} one
   * @param {number} i
   */
  function (one, i) {
    styles[i] = (0, _reshowConstant.NEW_OBJ)();
    (0, _reshowConstant.KEYS)(one).forEach(function (key) {
      if ((0, _reshowConstant.IS_ARRAY)(one[key]) && 1 === one[key].length) {
        var ucFirstKey = (0, _ucfirstJs["default"])(key);
        styles[i][Browser.webkit + ucFirstKey] = styles[i][Browser.ms + ucFirstKey] = styles[i][Browser.moz + ucFirstKey] = styles[i][key] = (0, _cssNumberToUnit["default"])(key, one[key][0]);
      } else {
        styles[i][key] = (0, _cssNumberToUnit["default"])(key, one[key]);
      }
    });
  });
  var styleDecl;
  if (thisStyleId) {
    styleDecl = new _StyleObject["default"](styles, selector, thisStyleId);
    _store["default"].newStyles.push(styleDecl);
  } else {
    // will not push to injectStyle queue
    styleDecl = new _StyleObject["default"](styles);
  }
  return styleDecl;
};
var _default = exports["default"] = createStyle; // reactStyle(css, selector, styleId)
module.exports = exports.default;